import { Component, OnInit, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpService } from '../../services/http.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ambassadors',
  templateUrl: './ambassadors.component.html',
  styleUrls: ['./ambassadors.component.scss']
})
export class AmbassadorsComponent implements OnInit {

  @Output() closeClick = new EventEmitter();
  contributors = [];
  month = '';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private httpService: HttpService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.translate.use(sessionStorage.getItem('language'));
      this.httpService.getAmbassadors()
        .subscribe((data) => {
          if (data.err_code === 0) {
            this.contributors = data.data.contributors;
          } else {
            console.log(data);
          }
        });
      this.month = new Intl.DateTimeFormat(sessionStorage.getItem('language'), { month: 'long' }).format(new Date());
    }
  }

  closeAmbassadors() {
    this.closeClick.emit();
  }

}
